import type { PremiumFeatures } from '@lub0v/santa-utils';
import { gameAccessTier, premiumTierName } from '@src/components/PremiumBadge/tierIdentity';
import { PremiumBadge } from '@src/components/PremiumBadge/PremiumBadge';
import './GamePageShell.css';
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { Stack } from '@src/components';
import { PageHeading } from '@src/components/PageHeading/PageHeading';
import type { BoxRoute } from '@src/routing/routes';

const headings: Partial<Record<BoxRoute['view'], readonly [string, string]>> = {
  settings: ['game.settings.title', 'game.settings.subtitle'],
  organizer: ['game.nav.organizerPanel', 'game.managementSubtitle'],
  exchange: ['game.exchange.title', 'game.exchange.subtitle'],
  messenger: ['game.messenger.title', 'game.messenger.subtitle'],
};

/** Owns the heading and spacing between navigation, page introduction, and content. */
export function GamePageShell({ view, children, showHeading = true, premium = false, features, className = '', headingClassName = '', testId }: {
  view: BoxRoute['view'];
  children: ReactNode;
  showHeading?: boolean;
  premium?: boolean;
  features?: PremiumFeatures;
  className?: string;
  headingClassName?: string;
  testId?: string;
}) {
  const { t, i18n } = useTranslation();
  const tier = gameAccessTier(features);
  const heading = headings[view];
  return <Stack gap={6} wide className={`game-page-shell ${className}`} testId={testId}>
    {showHeading && heading && <div className={`game-page-shell__heading ${headingClassName}`}>
      <PageHeading title={<span className="game-page-shell__title">{t(heading[0])}{premium && (view === 'organizer' || view === 'settings') && <PremiumBadge tier={tier}>{tier ? premiumTierName(tier, i18n.language.startsWith('ru')) : t('game.premiumGame')}</PremiumBadge>}</span>} subtitle={t(heading[1])} />
    </div>}
    {children}
  </Stack>;
}
